"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const CreatePasswordForm = (props) => {
    const params = (0, react_router_dom_1.useParams)();
    const { createPasswordStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { email, passwordError2, passwordError } = createPasswordStore;
    const handlePasswordValue = (value, id) => {
        createPasswordStore.getValue(value, id);
    };
    const createPassword = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const activatingCode = params.activatingCode;
        if (!activatingCode) {
            return;
        }
        props.setLoading(true);
        yield createPasswordStore.createPassword(activatingCode);
        props.setLoading(false);
    });
    return (react_1.default.createElement("div", { className: "global-container" },
        react_1.default.createElement("form", { className: "create-password-form", onSubmit: createPassword },
            react_1.default.createElement("h3", null, "Set your account password"),
            react_1.default.createElement("p", null,
                "Please set the password associated with ",
                react_1.default.createElement("br", null),
                " address ",
                react_1.default.createElement("strong", null, email)),
            react_1.default.createElement("span", { className: "line" },
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'password', label: 'Password', errorMessage: passwordError, onChange: handlePasswordValue, required: true, password: true }),
                react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Passwords must contain at least 10 characters with at ' +
                        'least one upper case, one lower case, one number and one' +
                        ' special character.' })),
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'password2', label: 'Re enter password', required: true, errorMessage: passwordError2, onChange: handlePasswordValue, password: true }),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: !createPasswordStore.isPasswordValid || props.loading }, "Submit"))));
};
exports.default = (0, mobx_react_1.observer)(CreatePasswordForm);
